export default {
	'展位号': '展位号',
	'展位面积': '展位面积',
	'参展商': '参展商',
	'搭建商群': '搭建商群',
	'展位图纸': '展位图纸',
	'展位信息确认': '展位信息确认',
	'注：请核对展位相关信息（面积尺寸、高度限制、设计方案开口消防要求）务必确定无误方可开始报图。': '注：请核对展位相关信息（面积尺寸、高度限制、设计方案开口消防要求）务必确定无误方可开始报图。',
	'如有问题请先联系施工安全管理（联系方式见首页联系主场）': '如有问题请先联系施工安全管理（联系方式见首页联系主场）',
	'提示信息': '提示信息',
	'当前展位已报图，但': '当前展位已报图，但',
	'请耐心等待审图结果': '请耐心等待审图结果。',
	'您可以在审图列表中修改申请或取消后重新申请': '您可以在审图列表中修改申请或取消后重新申请',
	'该展位已通过审图，请勿重复提交。': '该展位已通过审图，请勿重复提交。',
	'上一步': '返回',
	'购买保险': '购买保险',
	'跳过': '跳过',
	'下一步': '下一步',
	'报图截止时间：': '报图截止时间：',
	'请在报图截止时间之前提交报图资料，若超过截止时间提交，每个过审展位都将收取延时审图费用，请您知悉！': '请在报图截止时间之前提交报图资料，若超过截止时间提交，每个过审展位都将收取延时审图费用，请您知悉！',
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/drawings/drawingsBoothConfirm.js